import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../../constants/apiConfig';
import { SafetyMessageDto } from '../../../types/iapBaseTypes';
import { keys } from './useCreateSafetyMessage';
import { useActualIncidentId } from './commonHooks';

export const getSafetyMessagesByIncidentId = async (incidentId: string) => {
  const response = await axios.get<SafetyMessageDto[]>(
    `${config.apiGateway.ics_safety_messages}/${incidentId}`
  );
  return response.data;
};
export const useSafetyMessages = () => {
  const incidentId = useActualIncidentId();
  return useQuery({
    queryKey: [keys.safetyMessages, incidentId],
    queryFn: () => getSafetyMessagesByIncidentId(incidentId),
    enabled: !!incidentId,
  });
};
